import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-id", "data-item-id", "data-artnr", "data-wban"]
const _hoisted_2 = {
  key: 0,
  class: "product-box-set-item__image-container"
}
const _hoisted_3 = {
  key: 0,
  class: "product-flags product-box-set-item__product-flags"
}
const _hoisted_4 = { class: "product-box-set-item__picture" }
const _hoisted_5 = { class: "product-box-set-item__body" }
const _hoisted_6 = { class: "product-box-set-item__main-info" }
const _hoisted_7 = { class: "product-box-set-item__quickfacts-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "product-box-set-item__image-container"
}
const _hoisted_9 = {
  key: 0,
  class: "product-flags product-box-set-item__product-flags"
}
const _hoisted_10 = { class: "product-box-set-item__picture" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 2,
  class: "product-box-set-item__longDescription product-box-set-item__longDescription--empty"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "product-box-set-item__longDescription product-box-set-item__longDescription--empty"
}
const _hoisted_16 = {
  key: 2,
  class: "product-box-set-item__conversion"
}
const _hoisted_17 = ["href", "innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flags = _resolveComponent("flags")!
  const _component_image_element = _resolveComponent("image-element")!
  const _component_product_box_segment_header = _resolveComponent("product-box-segment-header")!
  const _component_quickfacts = _resolveComponent("quickfacts")!
  const _component_price_info_oldest = _resolveComponent("price-info-oldest")!

  return (_openBlock(), _createElementBlock("div", {
    class: "product-box product-box-set-item",
    "data-id": _ctx.productBoxData.id,
    "data-item-id": _ctx.productBoxData.itemId,
    "data-artnr": _ctx.productBoxData.trackingData.artNr,
    "data-wban": _ctx.productBoxData.trackingData.wban
  }, [
    (!$setup.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(), _createBlock(_resolveDynamicComponent($setup.productLink ? 'a' : 'div'), {
            href: $setup.productLink,
            "aria-label": _ctx.productBoxData.linked ? _ctx.productBoxData.description1 : null,
            class: "product-box__image-wrapper"
          }, {
            default: _withCtx(() => [
              (_ctx.productBoxData.flags)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_flags, {
                      flags: _ctx.productBoxData.flags,
                      limit: 4,
                      "award-limit": 2,
                      "white-list": _ctx.settings.flags.whitelistInSet
                    }, null, 8 /* PROPS */, ["flags", "white-list"])
                  ]))
                : _createCommentVNode("v-if", true),
              _cache[0] || (_cache[0] = _createTextVNode()),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_image_element, {
                  class: "product-box-set-item__image",
                  src: $setup.imgSrc,
                  alt: _ctx.productBoxData.images[0].alt
                }, null, 8 /* PROPS */, ["src", "alt"])
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["href", "aria-label"]))
        ]))
      : _createCommentVNode("v-if", true),
    _cache[9] || (_cache[9] = _createTextVNode()),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_product_box_segment_header, {
        class: "product-box-set-item__segment-header",
        "product-box-data": _ctx.productBoxData,
        state: _ctx.state,
        "number-of-bottles-in-set": _ctx.productBoxData.numberOfBottlesInSet && _ctx.productBoxData.numberOfBottlesInSet > 1 ? _ctx.productBoxData.numberOfBottlesInSet : null,
        "product-link": $setup.productLink,
        onWishlistClicked: _ctx.toggleWishlist
      }, null, 8 /* PROPS */, ["product-box-data", "state", "number-of-bottles-in-set", "product-link", "onWishlistClicked"]),
      _cache[8] || (_cache[8] = _createTextVNode()),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          ($setup.isMobile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.productBoxData.flags)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_flags, {
                        flags: _ctx.productBoxData.flags,
                        limit: 4,
                        "award-limit": 2,
                        "white-list": _ctx.settings.flags.whitelistInSet
                      }, null, 8 /* PROPS */, ["flags", "white-list"])
                    ]))
                  : _createCommentVNode("v-if", true),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.productBoxData.linked ? 'a' : 'div'), {
                  href: _ctx.productBoxData.linked ? _ctx.productBoxData.url : null,
                  "aria-label": _ctx.productBoxData.linked ? _ctx.productBoxData.description1 : null,
                  class: "product-box__image-wrapper"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_image_element, {
                        class: "product-box-set-item__image",
                        src: $setup.imgSrc,
                        alt: _ctx.productBoxData.images[0].alt,
                        title: _ctx.productBoxData.images[0].title,
                        enabled: _ctx.productBoxData.lazyLoadImages
                      }, null, 8 /* PROPS */, ["src", "alt", "title", "enabled"])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["href", "aria-label"]))
              ]))
            : _createCommentVNode("v-if", true),
          _cache[3] || (_cache[3] = _createTextVNode()),
          ($props.showQuickfactsWithDesc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (!$props.hideQuickfacts)
                  ? (_openBlock(), _createBlock(_component_quickfacts, {
                      key: 0,
                      class: "product-box-set-item__quickfacts",
                      quickfacts: $setup.quickfactList,
                      "use-links": false
                    }, null, 8 /* PROPS */, ["quickfacts"]))
                  : _createCommentVNode("v-if", true),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (_ctx.productBoxData.longDescription)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "product-box-set-item__longDescription",
                      innerHTML: $setup.getLongText(_ctx.productBoxData.longDescription)
                    }, null, 8 /* PROPS */, _hoisted_12))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13))
              ]))
            : _createCommentVNode("v-if", true),
          _cache[4] || (_cache[4] = _createTextVNode()),
          (!$props.hideQuickfacts)
            ? (_openBlock(), _createBlock(_component_quickfacts, {
                key: 2,
                class: _normalizeClass(["product-box-set-item__quickfacts", [`product-box-set-item__quickfacts--length-${$setup.quickfactList.length}`]]),
                quickfacts: $setup.quickfactList,
                "use-links": false
              }, null, 8 /* PROPS */, ["class", "quickfacts"]))
            : _createCommentVNode("v-if", true)
        ]),
        _cache[6] || (_cache[6] = _createTextVNode()),
        (_ctx.productBoxData.longDescription && !$props.showQuickfactsWithDesc)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "product-box-set-item__longDescription",
              innerHTML: $setup.getLongText(_ctx.productBoxData.longDescription)
            }, null, 8 /* PROPS */, _hoisted_14))
          : (_openBlock(), _createElementBlock("div", _hoisted_15)),
        _cache[7] || (_cache[7] = _createTextVNode()),
        (_ctx.productBoxData.price || _ctx.productBoxData.linked)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              (_ctx.productBoxData.price && !_ctx.productBoxData.purchaseOnRequestArticle)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["product-box__price-wrapper", `price-info--currency-${_ctx.productBoxData.price.currency}`])
                  }, [
                    _createVNode(_component_price_info_oldest, {
                      class: "product-box__price",
                      value: _ctx.productBoxData.price,
                      "show-star": false
                    }, null, 8 /* PROPS */, ["value"])
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              _cache[5] || (_cache[5] = _createTextVNode()),
              (_ctx.productBoxData.linked)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: _ctx.productBoxData.url,
                    class: "product-box-set-item__button button button--text",
                    innerHTML: _ctx.$t('detail.product.moreDetails')
                  }, null, 8 /* PROPS */, _hoisted_17))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}